// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","wrapper":"styles_wrapper__v2Jkx","container":"styles_container__s7Fkz","title":"styles_title__1OKma","metrics":"styles_metrics__TOi_C"};